import { useEffect } from "react";
import { ROUTES, SideBarMenus } from "routes/constants";
import { getRoute } from "routes/utils";
import { HasPermission } from "utils/CheckPermissions";
import { getSignalRConnection } from "utils/signalRConnection";

import { useNotification } from "./notification-context";


interface ExitGateData {
  Title: string;
  Message: string;
  EntryId : string;
}

export const NotificationListener = ({ user }: { user: any }) => {
  const checkPermissions = HasPermission(SideBarMenus.NOTIFICATIONS, "view");
  const { incrementUnread } = useNotification();

  useEffect(() => {
    if (!user || !checkPermissions) return;

    const connection = getSignalRConnection();

    // Function to attach handlers
    const attachHandlers = () => {
    //   connection.on("ExitGateRequest", (rawData: any) => {
    //     const data: ExitGateData = JSON.parse(rawData);

    //     if (Notification.permission === "granted") {
    //       const notification = new Notification(data.Title || "New Message", {
    //         body: data.Message || "You have a new notification",
    //         icon: "/icon.png",
    //       });

    //       incrementUnread();

    //       notification.onclick = () => {
    //         window.location.href = getRoute(ROUTES.NOTIFICATION, 0);
    //       };
    //     } else {
    //       Notification.requestPermission();
    //     }
    //   });


      connection.on("exitgaterequest", (rawData: any) => {
        const data: ExitGateData = JSON.parse(rawData);

        if (Notification.permission === "granted") {
          const notification = new Notification(data.Title || "New Message", {
            body: data.Message || "You have a new notification",
            icon: "/icon.png",
          });

          incrementUnread();

          notification.onclick = () => {
          const url = getRoute(ROUTES.LOG_ADMIN_DETAIL, data.EntryId);
            window.open(url,'_blank');
          };
        } else {
          Notification.requestPermission();
        }
      });
    };

    // Attach handlers initially
    attachHandlers();

    // Start connection if disconnected
    if (connection.state === "Disconnected") {
      connection.start().catch((err) => console.error("SignalR error:", err));
    }

    // Re-attach handlers on reconnect
    connection.onreconnected(() => {
      //console.log("🔄 SignalR reconnected — re-attaching handlers");
      attachHandlers();
    });

    return () => {
      connection.off("ExitGateRequest"); // cleanup
    };
  }, [user, checkPermissions]);

  return null;
};